import Spinner from "react-bootstrap/Spinner";

export default function Wait (props)
{
    return (
	<div className="position-fixed w-100 vh-100" style={{ zIndex: 9999 }}>
	    <div className="position-absolute w-100 vh-100 bg-dark opacity-50"/>
	    <div className="position-absolute top-50 w-100 text-center">
		<Spinner animation="border" role="status">
		    <span className="visually-hidden">Loading...</span>
		</Spinner>
	    </div>
	</div>
    );
}
